
import MerchSliderDesktop from "@/merchandising/merchandising"
  


export default async () => {
      // merchandising

  if (window.seasonManager.isSummer()) { // TEMPORARY - disable and remove merch for summer until a solution is found
    // console.log(`hiding merch on summer`)
    const merchSection = document.querySelector("section.tf-merchandising")
    if (merchSection) merchSection.remove() // TODO change to display none
    return
  }

  if (window.screenSizeManager.screenType!=='mobile') {
    window.merchSliders = []

    Array.from(document.querySelectorAll('.merchandising-slider-desktop-wrapper')).forEach((sliderRoot) => {
      const slider = new MerchSliderDesktop(sliderRoot)
      slider.init()
      window.merchSliders.push(slider)
    })
  }
}